import { render, staticRenderFns } from "./traineeDashboard.vue?vue&type=template&id=726945b4&scoped=true"
import script from "./traineeDashboard.vue?vue&type=script&lang=js"
export * from "./traineeDashboard.vue?vue&type=script&lang=js"
import style0 from "./traineeDashboard.vue?vue&type=style&index=0&id=726945b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726945b4",
  null
  
)

export default component.exports